export default __webpack_public_path__ + "static/media/SubaruFavicon.094790d1.ico";